import React from "react";
import PropTypes from "prop-types";
import Link from "@material-ui/core/Link";
import Typography from "@material-ui/core/Typography";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { makeStyles } from "@material-ui/core";
import { childrenType } from "../types";
import Image from "../components/Image";
import imageUrlFor from "./image-url";

const useStyles = makeStyles((theme) => ({
  mainImage: {
    width: "100%",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat",
    backgroundPosition: "center",
    marginBottom: theme.spacing(4),
  },
  list: {
    display: "list-item",
    marginLeft: theme.spacing(4),
  },
  unorderedList: {
    listStyle: "disc",
  },
  orderedList: {
    listStyle: "decimal",
  },
}));

const serializers = {
  types: {
    block: ({ children, node }) => {
      const { style = "normal" } = node;

      if (/^h\d/.test(style)) {
        const level = style.replace(/[^\d]/g, "");
        return (
          <Typography variant={`h${level}`} gutterBottom>
            {children}
          </Typography>
        );
      }

      if (style === "blockquote") {
        return (
          <Typography variant="body1" component="blockquote" gutterBottom>
            {children}
          </Typography>
        );
      }

      return (
        <Typography variant="body1" gutterBottom>
          {children}
        </Typography>
      );
    },
    mainImage: ({ node }) => {
      const classes = useStyles();
      const { asset, alt } = node;
      const src = imageUrlFor(asset).url();
      return <Image className={classes.mainImage} src={src} alt={alt} />;
    },
  },
  list: ({ children, type }) => {
    const classes = useStyles();
    return (
      <List
        className={`${classes.list} ${
          type === "bullet" ? classes.unorderedList : classes.orderedList
        }`}
        dense
        component={type === "bullet" ? "ul" : "ol"}
      >
        {children}
      </List>
    );
  },
  listItem: ({ children }) => {
    return (
      <ListItem disableGutters dense>
        <ListItemText>{children}</ListItemText>
      </ListItem>
    );
  },
  marks: {
    link: ({ mark, children }) => {
      const { href } = mark;
      return <Link href={href}>{children}</Link>;
    },
  },
};

serializers.types.block.defaultProps = {
  node: {
    style: "normal",
  },
  children: [],
};

serializers.types.block.propTypes = {
  node: PropTypes.shape({ style: PropTypes.string }),
  children: childrenType,
};

serializers.types.mainImage.defaultProps = {
  node: null,
};

serializers.types.mainImage.propTypes = {
  node: PropTypes.shape({
    asset: PropTypes.shape({ _ref: PropTypes.string }),
    alt: PropTypes.string,
  }),
};

serializers.list.defaultProps = {
  type: "bullet",
  children: [],
};

serializers.list.propTypes = {
  type: PropTypes.string,
  children: childrenType,
};

serializers.listItem.defaultProps = {
  children: [],
};

serializers.listItem.propTypes = {
  children: childrenType,
};

serializers.marks.link.propTypes = {
  mark: PropTypes.shape({ href: PropTypes.string }),
  children: childrenType,
};

serializers.marks.link.defaultProps = {
  mark: null,
  children: [],
};

export default serializers;
